import type {NavigateFunction} from "react-router-dom";

import type {Me} from "@/src/modules/core/types";
import type {Property} from "@/src/modules/properties/types";

import {applyDispatchDeskPropertyChange} from "./apply-dispatch-desk-property";
import {formatDispatchResidentLine} from "./dispatch-desk-general-info";
import {useDispatchDeskHouseholdMatchStore} from "../store/desk-household-match";
import type {HouseholdAssistCandidate} from "../types/household-assist";

export function candidateToHouseholdShape(candidate: HouseholdAssistCandidate) {
  return {
    house_hold_id: candidate.house_hold_id,
    name: candidate.name,
    street: candidate.street,
    number: String(candidate.number ?? ""),
    state: "",
    city: "",
    zipcode: "",
    user_id: candidate.residents[0]?.user_id ?? 0,
    created_at: "",
    updated_at: "",
  };
}

type ApplyHouseholdAssistCandidateArgs = {
  candidate: HouseholdAssistCandidate;
  properties: Property[];
  currentProperty: Property | null;
  me: Me;
  pathname: string;
  navigate: NavigateFunction;
};

/** Resolve property from assist candidate, switch desk context, and store the match. */
export function applyHouseholdAssistCandidate({
  candidate,
  properties,
  currentProperty,
  me,
  pathname,
  navigate,
}: ApplyHouseholdAssistCandidateArgs): boolean {
  const property = properties.find((p) => String(p.id) === String(candidate.property_id));
  if (!property) return false;

  applyDispatchDeskPropertyChange({
    property,
    currentProperty,
    me,
    pathname,
    navigate,
  });
  useDispatchDeskHouseholdMatchStore.getState().setMatch(candidate);
  return true;
}

export function getFirstResidentDisplayName(candidate: HouseholdAssistCandidate): string | null {
  return formatDispatchResidentLine(candidate);
}
